import React from 'react'
import { AsideDefault } from './components/aside/AsideDefault'
import { Footer } from './components/Footer'
import { HeaderWrapper } from './components/header/HeaderWrapper'
import { Toolbar } from './components/toolbar/Toolbar'
import { ScrollTop } from './components/ScrollTop'
import { Content } from './components/Content'
import { MasterInit } from './MasterInit'
import { PageDataProvider } from './core'
import {
  DrawerMessenger,
  ExploreMain,
  ActivityDrawer,
  Main,
  InviteUsers,
  UpgradePlan,
} from '../partials'
import { isMobile } from 'react-device-detect';
import ReactLoading from 'react-loading';
import { useSelector } from 'react-redux'
import { RootState } from '../../setup/redux/RootReducer'

const MasterLayout: React.FC = ({ children }) => {

  const loadingState = useSelector((state: RootState) => state.setMainLoadingSlicer);

  console.log("Loading state =>", loadingState);

  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root'>
        <div className='page d-flex flex-row flex-column-fluid'>
          <AsideDefault />
          <div className={"d-flex flex-column flex-row-fluid " + (isMobile ? "" : "wrapper")} style={{ paddingTop: (isMobile ? "17%" : "auto") }} id='kt_wrapper'>
            <div style={{ display: loadingState.isActive ? 'block' : 'none', position: 'relative', zIndex: 98 }}>
              <div style={{ display: loadingState.isActive ? 'block' : 'none', margin: "0px", padding: "0px", width: "100%", height: "100%", position: "absolute" }}>
                <div style={{ display: loadingState.isActive ? 'flex' : 'none', justifyContent: 'center', zIndex: 99 }}>
                  <ReactLoading type={'spinningBubbles'} color={'#333'} height={'50px'} width={'15%'} />
                </div>
              </div>
            </div>
            <HeaderWrapper />


            <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
              {<Toolbar />}
              <div className='post d-flex flex-column-fluid' id='kt_post' style={{ marginTop: isMobile ? '15%' : '0%' }}>
                <Content>{children}</Content>
              </div>
            </div>


            <Footer />
          </div>
        </div>
      </div>

      {/* begin:: Modals */}
      <Main />
      <InviteUsers />
      <UpgradePlan />
      {/* end:: Modals */}

      <MasterInit />
      <ScrollTop />
    </PageDataProvider>
  )
}

export { MasterLayout }
